import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isChangeBan: null,
};

const changeBanSlice = createSlice({
    name: 'changeBan',
    initialState,
    reducers: {
        setIsChangeBan: (state, action) => {
            state.isChangeBan = action.payload
        }
    }
})

export const { setIsChangeBan } = changeBanSlice.actions;
export const changeBan = changeBanSlice.reducer;